import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="anchor-offset">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">常见问题</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            关于爱情岛，你可能想先弄清楚这些
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`flex flex-col rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="flex items-start gap-3">
                    <span className="font-heading text-sm text-primary-600">{String(index + 1).padStart(2, "0")}</span>
                    <span className="font-heading text-base text-foreground-950">{faq.q}</span>
                  </span>
                  <i
                    className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-lg text-foreground-500`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 pl-[52px] text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}